module.exports = __webpack_public_path__ + "static/eternal_flame_guardian-3d0e9c285578fa411e8d8458d6f222b8.jpeg";